module.exports = __webpack_public_path__ + "static/media/003_executive_summary_modelview.963b5166.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/intel/003_executive_summary_modelview.png
// module id = 474
// module chunks = 0